import SEO from "@/components/SEO";
import { PrimaryCTA } from "@/components/CTAButton";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | All Data Tech" description="The page you are looking for does not exist." />
      <section className="relative flex min-h-[70vh] items-center justify-center overflow-hidden bg-[#F7F8FA] pt-24">
        <div className="absolute inset-0 grid-pattern-light opacity-50" aria-hidden="true" />
        <div className="ad-container relative text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-[#1677FF]">404</p>
          <h1 className="mt-4 display-lg text-[#111827]">This data point is <span className="text-gradient">missing.</span></h1>
          <p className="mx-auto mt-5 max-w-md text-[#4B5563]">The page you're looking for doesn't exist. Let's get you back to something useful.</p>
          <div className="mt-8 flex justify-center">
            <PrimaryCTA to="/" testId="notfound-home">Back to Home</PrimaryCTA>
          </div>
        </div>
      </section>
    </>
  );
}
